// extracted by mini-css-extract-plugin
export default {"wrapper":"PositionsCompatibility_wrapper__ZHKdd","card":"PositionsCompatibility_card__dA5ko","tag":"PositionsCompatibility_tag__+M2oX","title":"PositionsCompatibility_title__bIyAH"};